module.exports = __webpack_public_path__ + "img/Green.741aa342.jpg";